/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OutputAllMenuPagesPermissionDto } from '../../models/output-all-menu-pages-permission-dto';

export interface UserManagementGetMenusPagesPermissionsGet$Plain$Params {
}

export function userManagementGetMenusPagesPermissionsGet$Plain(http: HttpClient, rootUrl: string, params?: UserManagementGetMenusPagesPermissionsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OutputAllMenuPagesPermissionDto>>> {
  const rb = new RequestBuilder(rootUrl, userManagementGetMenusPagesPermissionsGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OutputAllMenuPagesPermissionDto>>;
    })
  );
}

userManagementGetMenusPagesPermissionsGet$Plain.PATH = '/UserManagement/GetMenusPagesPermissions';
